export type BroadsheetTokens = {
  newsprint: string;
  newsprintRaised: string;
  panelSurface: string;
  ink: string;
  inkMuted: string;
  ruleHairline: string;
  kicker: string;
  required: string;
  ruleMasthead: string;
  coverPlate: string;
  coverPlateText: string;
  spineTeal: string;
  spineGreen: string;
  spineGold: string;
  spineRust: string;
  spineIndigo: string;
  footerBand: string;
  footerText: string;
  footerRule: string;
  link: string;
  linkHover: string;
  inverted: string;
  /* Surface for third-party artwork (logos, badges); stays white in dark mode. */
  logoPlate: string;
  subtitleText: string;
  socialIcon: string;
  socialIconHover: string;
};

export const broadsheetLight: BroadsheetTokens = {
  newsprint: "#FAF9F5",
  newsprintRaised: "#FAF9F5",
  panelSurface: "#FFFDF7",
  ink: "#3d3a33",
  inkMuted: "#656d75",
  ruleHairline: "#d3c4ad",
  kicker: "#7d6b3a",
  required: "#b04a2e",
  ruleMasthead: "#3d3a33",
  coverPlate: "linear-gradient(135deg, #e3ddd2 0%, #dad3c6 100%)",
  coverPlateText: "#5e5749",
  spineTeal: "#0b7783",
  spineGreen: "#1f7a4c",
  spineGold: "#8a7433",
  spineRust: "#9c4f2f",
  spineIndigo: "#4a5691",
  footerBand: "#08545c",
  footerText: "#abd1c6",
  footerRule: "rgba(171, 209, 198, 0.5)",
  link: "#007884",
  linkHover: "#005f69",
  inverted: "#ffffff",
  logoPlate: "#ffffff",
  subtitleText: "#81683b",
  socialIcon: "rgba(0, 0, 0, 0.2)",
  socialIconHover: "rgba(0, 0, 0, 0.8)",
};

export const broadsheetDark: BroadsheetTokens = {
  newsprint: "#2f2e2c",
  newsprintRaised: "#3a3937",
  panelSurface: "#423f3b",
  ink: "#e7e3d9",
  inkMuted: "#b2b2b2",
  ruleHairline: "#55534d",
  kicker: "#c0ab78",
  required: "#e08e70",
  ruleMasthead: "#8c877b",
  coverPlate: "linear-gradient(135deg, #3a3937 0%, #2b2a28 100%)",
  coverPlateText: "#aca595",
  spineTeal: "#5ec2ce",
  spineGreen: "#5fc98d",
  spineGold: "#d3b976",
  spineRust: "#e0906f",
  spineIndigo: "#9aa6e0",
  footerBand: "#08545c",
  footerText: "#abd1c6",
  footerRule: "rgba(171, 209, 198, 0.5)",
  link: "#3ad8e7",
  linkHover: "#13d0e3",
  inverted: "#333333",
  logoPlate: "#ffffff",
  subtitleText: "#d3b976",
  socialIcon: "rgb(69, 122, 130)",
  socialIconHover: "rgb(74, 189, 205)",
};

export const BROADSHEET_MODE_ATTR = "data-bf-mode";

export const broadsheetCssVars = (
  tokens: BroadsheetTokens,
  selector = ":root",
) => ({
  [selector]: {
    "--bf-newsprint": tokens.newsprint,
    "--bf-newsprint-raised": tokens.newsprintRaised,
    "--bf-panel-surface": tokens.panelSurface,
    "--bf-ink": tokens.ink,
    "--bf-ink-muted": tokens.inkMuted,
    "--bf-rule": tokens.ruleHairline,
    "--bf-kicker": tokens.kicker,
    "--bf-required": tokens.required,
    "--bf-rule-masthead": tokens.ruleMasthead,
    "--bf-cover-plate": tokens.coverPlate,
    "--bf-cover-plate-text": tokens.coverPlateText,
    "--bf-spine-teal": tokens.spineTeal,
    "--bf-spine-green": tokens.spineGreen,
    "--bf-spine-gold": tokens.spineGold,
    "--bf-spine-rust": tokens.spineRust,
    "--bf-spine-indigo": tokens.spineIndigo,
    "--bf-footer-band": tokens.footerBand,
    "--bf-footer-text": tokens.footerText,
    "--bf-footer-rule": tokens.footerRule,
    "--bf-link": tokens.link,
    "--bf-link-hover": tokens.linkHover,
    "--bf-inverted": tokens.inverted,
    "--bf-logo-plate": tokens.logoPlate,
    "--bf-subtitle-text": tokens.subtitleText,
    "--bf-social-icon": tokens.socialIcon,
    "--bf-social-icon-hover": tokens.socialIconHover,
  },
});
